class $bf9c8ef13caafaee$export$a76751f64184c07 {
    /**
     * Instantiate a flow
     */ constructor(){
        this.steps = [];
        this.current = -1;
    }
    /**
     * Add a node to the flow. A node is either automated computation (a JS function) or human-computation
     * (a user interface). The node is wrapped as a QStep, which is returned from this method
     * @param node 
     */ add(node) {
        var step;
        this.steps.push(step = new $bf9c8ef13caafaee$export$973d42224d50092f(node));
        return step;
    }
    /**
     * Move to the first node, and initialise the state
     */ start() {
        if (this.steps.length < 1) throw "Cannot start a flow with no steps defined";
        this.current = 0;
        var currentStep = this.steps[this.current];
        currentStep.setInState({});
        this.go(this.steps[0]);
    }
    /**
     * Move to the next step. The current step must be passed in
     */ next(state, current) {
        // Find the current step in the step list
        for(var stepN = 0; this.steps[stepN] !== current; stepN++);
        // Then find the next one
        var nextStep = null;
        if (this.steps.length > stepN) nextStep = this.steps[stepN + 1];
        //console.debug("Next step is", nextStep);
        if (!nextStep) throw "There is no next step defined";
        // Cache the incoming state into the step
        //console.debug("Set state", state);
        nextStep.setInState(structuredClone(state));
        // Then run the step
        this.go(nextStep);
    }
    /**
     * Go to a specific step using the given state
     */ goto(step, state) {
        step.setInState(structuredClone(state));
        this.go(step);
    }
    /**
     * Go back to the last 'visible' step
     */ back(currentStep) {
        for(var i = 0; this.steps[i] !== currentStep; i++);
        //console.debug("Current step is", i, currentStep);
        for(var i = i - 1; i >= 0; i--){
            var step = this.steps[i];
            // We can only go back to steps that are visible (ie not just logical nodes)
            // and which have instate set (i.e. have been used before)
            if (step.getNode().isVisible() && step.hasInState()) {
                this.backTo(step);
                return;
            }
        }
        // Otherwise throw an exception
        throw "Cannot go back in a step list with no prior visible steps";
    }
    /**
     * Go back to the given QStep. The step must be part of the history, otherwise
     * an exception will be thrown
     */ backTo(step) {
        for(var i = 0; i < this.steps.length; i++)if (this.steps[i] === step) {
            if (!step.hasInState()) throw "Cannot go back to a step that has no previous state";
            this.go(step);
            return;
        }
        // Otherwise throw an exception
        throw "Cannot go to a step that was not found in the step list";
    }
    /**
     * Run the given step. State should be set up on the step before this method is
     * called.
     */ go(step) {
        // Check the step exists and update the internal pointer
        for(var i = 0; i < this.steps.length; i++)if (this.steps[i] === step) {
            var currentStep = this.steps[i];
            var node = step.getNode();
            var state = structuredClone(currentStep.getInState());
            node.go(state, (state, step)=>{
                // No argument, go to the next step
                if (typeof step == "undefined") this.next(state, currentStep);
                else if (!isNaN(Number(step)) && Number(step) < 0) this.back(currentStep);
                else if (step instanceof $bf9c8ef13caafaee$export$973d42224d50092f) this.goto(step, state);
            });
            return;
        }
        // Otherwise throw an exception
        throw "Cannot go to a step that was not found in the step list";
    }
}
/**
 * Represents a step in a flow. Steps have a node that defines the step's behaviour and potentially some
 * historic state that represents the state that was passed in last time the step was run; so that we can
 * go back to the step without side-effects caused by later steps
 */ class $bf9c8ef13caafaee$export$973d42224d50092f {
    constructor(node){
        this.node = node;
        this.inState = undefined;
    }
    hasInState() {
        return typeof this.inState !== "undefined";
    }
    getInState() {
        return this.inState ? this.inState : {};
    }
    setInState(state) {
        this.inState = state;
    }
    getNode() {
        return this.node;
    }
}
/**
 * A node is a piece of computation that needs to be added to the flow.
 */ class $bf9c8ef13caafaee$export$a1efeb488823d524 {
}



/**
 * This node implements logic using a callback, which should return a QStep (to go to) or false (to do nothing)
 */ class $860778f0765c75e9$var$LogicNode extends (0, $bf9c8ef13caafaee$export$a1efeb488823d524) {
    constructor(logic){
        super();
        this.logic = logic;
    }
    go(state, then) {
        var n = this.logic(state);
        //console.debug("Logic result", n);
        then(state, n);
    }
    isVisible() {
        return false;
    }
}
var $860778f0765c75e9$export$2e2bcd8739ae039 = $860778f0765c75e9$var$LogicNode;



/**
 * This node implements logic for simple forms. Each 
 */ class $411e150c2013c60a$var$FormNode extends (0, $bf9c8ef13caafaee$export$a1efeb488823d524) {
    constructor(content, { terminal: terminal = false, nextStr: nextStr = "Next", allowBack: allowBack = true, backStr: backStr = "Back" }){
        super();
        this.content = content;
        this.opts = {
            terminal: terminal,
            nextStr: nextStr,
            allowBack: allowBack,
            backStr: backStr
        };
        // Set up buttons
        if (this.opts.allowBack) {
            this.content.appendChild(this.bbtn = document.createElement("button"));
            this.bbtn.innerHTML = this.opts.backStr;
        }
        if (!this.opts.terminal) {
            this.content.appendChild(this.nbtn = document.createElement("button"));
            this.nbtn.innerHTML = this.opts.nextStr;
        }
    }
    /**
     * Get input elements in this form
     */ getInputs() {
        var els = this.content.querySelectorAll("input, select");
        var out = [];
        for (var e of els){
            var name = e.getAttribute("name");
            // This should never happen, but it reassures the static type checker
            if (!(e instanceof HTMLInputElement)) continue;
            if (name == null) continue;
            out.push({
                name: name,
                input: e
            });
        }
        return out;
    }
    /** 
     * Find state in this form
     * We look for form elements, basically
     */ getState() {
        var els = this.getInputs();
        var state = {};
        //console.debug("Found elements in FormNode", els);
        for (var input of els){
            var value;
            // TODO: This might not work with radios?
            if (input.input instanceof HTMLSelectElement || input.input instanceof HTMLInputElement) {
                if (input.input.getAttribute("type") == "radio") {
                    if (!input.input.checked) continue;
                    else value = input.input.value;
                } else value = input.input.value;
            } else continue;
            state[input.name] = value;
        }
        return state;
    }
    /**
     * Apply the given state to elements in this form
     */ applyState(state) {
        var els = this.getInputs();
        for (var input of els)if (typeof state[input.name] !== "undefined") {
            // Radio buttons work a bit differently
            if (input.input.getAttribute("type") == "radio") input.input.checked = state[input.name] == input.input.value;
            else input.input.value = state[input.name].toString();
        }
    }
    /**
     * Initialise this node with the given state and callback function
     * @param state: The incoming state, which this node may modify and then pass back using the then() callback
     * @param then: A callback to update state and move to another step (see QThenFunction)
     */ go(state, then) {
        //console.log(this);
        // Focus our content element
        this.content.scrollIntoView({
            behavior: "auto"
        });
        // Restore state
        this.applyState(state);
        // Set up next button
        if (this.nbtn) this.nbtn.onclick = ()=>{
            var newstate = this.getState();
            for(var k in newstate)state[k] = newstate[k];
            then(state);
        };
        //  Set up a back button if enabled
        if (this.bbtn) this.bbtn.onclick = ()=>{
            then({}, -1);
        };
    // TODO: Also do history stuff so back button works as back
    // TODO: If back is disabled, prevent back button from doing anything?
    }
    isVisible() {
        return true;
    }
}
var $411e150c2013c60a$export$2e2bcd8739ae039 = $411e150c2013c60a$var$FormNode;


// Production path
var $712f7db91b372ab0$var$jsonRequest = new Request("https://www.smhn.org.uk/finder/getJSON.ajax.php");
// Local path
//var jsonRequest = new Request('http://www.smhn.alex.local/finder/getJSON.ajax.php');
var $712f7db91b372ab0$var$services = null;
// Promise JSON data
fetch($712f7db91b372ab0$var$jsonRequest).then((response)=>response.json()).then((data)=>{
    $712f7db91b372ab0$var$services = data;
    for (const service of $712f7db91b372ab0$var$services)for(let prop in service){
        let instRegex = /^(Inst)|^(Group)|^(Stage)/;
        if (instRegex.test(prop)) service[prop] = parseInt(service[prop]);
    }
    $712f7db91b372ab0$var$calculatePriority($712f7db91b372ab0$var$services);
    $712f7db91b372ab0$var$setStageButtonClickEvents();
    // Set urgent service card click events
    const urgentContainer = document.querySelector("#exit_urgent");
    //console.log("Loaded services", services);
    // TODO: Get rid of loading message :)
    $712f7db91b372ab0$var$flow.start();
// For debugging
/*
        flow.goto(exit_result, {
            who: "me",
            urgent: "no",
            age: "u16",
            school: "none",
            camhs: "yes",
            gender: "male",
            drug: "no",
            parent: "no",
            care: "yes"
        });
        */ }).catch(console.error);
var $712f7db91b372ab0$var$qs = (sel)=>{
    return document.querySelector(sel);
};
var $712f7db91b372ab0$var$flow = new (0, $bf9c8ef13caafaee$export$a76751f64184c07)();
/**
 * Set up nodes
 */ var $712f7db91b372ab0$var$intro = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#intro"), {
    nextStr: "Start",
    allowBack: false
}));
var $712f7db91b372ab0$var$q_confidential = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_confidential"), {}));
var $712f7db91b372ab0$var$q_who = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_who"), {}));
var $712f7db91b372ab0$var$gate_who = $712f7db91b372ab0$var$flow.add(new (0, $860778f0765c75e9$export$2e2bcd8739ae039)((state)=>{
    if (state.who == "me") $712f7db91b372ab0$var$changeGrammar("fp");
    else $712f7db91b372ab0$var$changeGrammar("tp");
}));
var $712f7db91b372ab0$var$q_urgent = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_urgent"), {}));
var $712f7db91b372ab0$var$gate_urgent = $712f7db91b372ab0$var$flow.add(new (0, $860778f0765c75e9$export$2e2bcd8739ae039)((state)=>{
    if (state.urgent == "yes") {
        $712f7db91b372ab0$var$appendResult($712f7db91b372ab0$var$services);
        $712f7db91b372ab0$var$setActiveResults(4);
        return $712f7db91b372ab0$var$exit_result;
    } else return $712f7db91b372ab0$var$q_age;
}));
var $712f7db91b372ab0$var$q_age = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_age"), {}));
var $712f7db91b372ab0$var$gate_age = $712f7db91b372ab0$var$flow.add(new (0, $860778f0765c75e9$export$2e2bcd8739ae039)((state)=>{
    if (state.age == "o25") return $712f7db91b372ab0$var$exit_elderly;
    else if (state.age == "1625") return $712f7db91b372ab0$var$q_school;
    else if (state.age == "u16") return $712f7db91b372ab0$var$exit_young;
}));
var $712f7db91b372ab0$var$exit_young = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#exit_young"), {
    terminal: true
}));
var $712f7db91b372ab0$var$exit_elderly = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#exit_elderly"), {
    terminal: true
}));
var $712f7db91b372ab0$var$q_school = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_school"), {}));
var $712f7db91b372ab0$var$gate_camhs = $712f7db91b372ab0$var$flow.add(new (0, $860778f0765c75e9$export$2e2bcd8739ae039)((state)=>{
    // Needn't ask about CAMHS for university students
    if (state.school == "uos" || state.school == "solent") return $712f7db91b372ab0$var$q_gender;
    else return $712f7db91b372ab0$var$q_camhs;
}));
var $712f7db91b372ab0$var$q_camhs = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_camhs"), {}));
// var q_soton = flow.add(new FormNode(qs('#q_soton'), {}));
var $712f7db91b372ab0$var$q_gender = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_gender"), {}));
var $712f7db91b372ab0$var$q_drug = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_drug"), {}));
var $712f7db91b372ab0$var$q_parent = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_parent"), {}));
var $712f7db91b372ab0$var$q_care = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_care"), {}));
var $712f7db91b372ab0$var$q_thanks = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_thanks"), {}));
var $712f7db91b372ab0$var$q_roadmap = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#q_roadmap"), {}));
var $712f7db91b372ab0$var$resultNode;
var $712f7db91b372ab0$var$exit_result = $712f7db91b372ab0$var$flow.add($712f7db91b372ab0$var$resultNode = new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#exit_result"), {
    terminal: true
}));
$712f7db91b372ab0$var$resultNode.oldGo = $712f7db91b372ab0$var$resultNode.go;
$712f7db91b372ab0$var$resultNode.go = function(state, then) {
    //console.log(this);
    this.oldGo(state, then);
    // Filter services, only return relevant
    var fs = $712f7db91b372ab0$var$filterServices(state, $712f7db91b372ab0$var$services);
    // Shuffle services with Fisher-Yates before sort to make displaying orgs fairer!
    function shuffleArray(array) {
        for(let i = array.length - 1; i > 0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    }
    const shuffledArray = shuffleArray(fs);
    shuffledArray.sort((a, b)=>{
        //console.log(a, a.priority, b, b.priority);
        return b.priority - a.priority;
    });
    //console.log(fs);
    // TO DO need a placeholder for empty stage containers - maybe also grey out stage button?
    // Create cards
    $712f7db91b372ab0$var$appendResult(fs);
    // Set result card click events
    let resultCards = document.querySelector("#exit_result");
};
var $712f7db91b372ab0$var$exit_generic = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#exit_generic"), {
    terminal: true
}));
var $712f7db91b372ab0$var$exit_urgent = $712f7db91b372ab0$var$flow.add(new (0, $411e150c2013c60a$export$2e2bcd8739ae039)($712f7db91b372ab0$var$qs("#exit_urgent"), {
    terminal: true
}));
/**
 * Helper functions
 */ // Change first or third person grammar active class
function $712f7db91b372ab0$var$changeGrammar(grammar) {
    let body = $712f7db91b372ab0$var$qs("body");
    body.className = grammar;
}
// Loops through array of service flags, adds a priority score
function $712f7db91b372ab0$var$calculatePriority(services) {
    for (const service of services){
        service.priority = 0;
        const flagArray = [
            service.Group_Alcohol,
            service.Group_CAMHS,
            service.Group_Drug,
            service.Group_Female,
            service.Group_LookedAfter,
            service.Group_Male,
            service.Group_Parent,
            service.Inst_CityCollege,
            service.Inst_ItchenCollege,
            service.Inst_RichardTaunton,
            service.Inst_Solent,
            service.Inst_UoS
        ];
        for(const i in flagArray)if (flagArray[i] > 0) service.priority += 10;
    }
}
// Loops through all services, returns array of just the applicable ones
function $712f7db91b372ab0$var$filterServices(state, services) {
    let out = [];
    for (const service of services)//console.log(service.Organisation.Name, checkService(state, service));
    if ($712f7db91b372ab0$var$checkService(state, service)) out.push(service);
    return out;
}
// Checks flags on a service against answers stored in state, returns false if
function $712f7db91b372ab0$var$checkService(state, iservice) {
    let service = {};
    Object.assign(service, iservice);
    // Filter age
    if (state.age === "u16") {
        if (service.MinAge > 15) {
            console.log("Users age " + state.age + " is lower than service minimum " + service.MinAge);
            return false;
        }
    } else if (state.age === "1625") {
        if (service.MaxAge < 16 && !service.MaxAge == 0) {
            console.log("Users age " + state.age + " is higher than service maximum " + service.MaxAge);
            return false;
        }
    } else throw "Unknown age " + state.age;
    // Filter gender
    if (state.gender === "male") {
        if (service.Group_Female == 1) {
            console.log("Users gender " + state.gender + " does not match service female gender requirement");
            return false;
        }
    } else if (state.gender === "female") {
        if (service.Group_Male == 1) {
            console.log("Users gender " + state.gender + " does not match service male gender requirement");
            return false;
        }
    } else if (state.gender === "other" || state.gender === "null") ;
    else throw "Unknown gender " + state.gender;
    // Filter schools
    // Create virtual restriction for case of no schools
    service.Inst_None = 0;
    let i = 0;
    for(const key in service)if (key.substring(0, 4) === "Inst") i += service[key];
    if (i === 0) {
        for(const key in service)if (key.substring(0, 4) === "Inst") service[key] = 1;
    }
    if (typeof state.school === "undefined" || state.school === "none") {
        if (service.Inst_None != 1) return false;
    } else if (state.school === "city") {
        if (service.Inst_CityCollege != 1) return false;
    } else if (state.school === "itchen") {
        if (service.Inst_ItchenCollege != 1) return false;
    } else if (state.school === "richard") {
        if (service.Inst_RichardTaunton != 1) return false;
    } else if (state.school === "uos") {
        if (service.Inst_UoS != 1) return false;
    } else if (state.school === "solent") {
        if (service.Inst_Solent != 1) return false;
    } else throw "Unknown school " + state.school;
    // To do add Camhs database values
    // Filter CAMHS
    if (state.camhs === "no") {
        if (service.Group_CAMHS == 1) {
            console.log("Users CAMHS eligibility " + state.camhs + " does not match service CAMHS requirement");
            return false;
        }
    }
    // Filter drugs
    if (state.drug === "no") {
        if (service.Group_Drug == 1 || service.Group_Alcohol == 1) {
            console.log("Users drugs/alcohol " + state.drug + " does not match service drug requirement");
            return false;
        }
    }
    // Filter parent
    if (state.parent === "no") {
        if (service.Group_Parent == 1) {
            console.log("Users parent/carer " + state.parent + " does not match service parent/carer requirement");
            return false;
        }
    }
    // Filter care
    if (state.care === "no") {
        if (service.Group_LookedAfter == 1) {
            console.log("Users former in care " + state.parent + " does not match service former care requirement");
            return false;
        }
    }
    return true;
}
// Takes an array of filtered and sorted services, creates card components in target element
function $712f7db91b372ab0$var$appendResult(filterServices) {
    $712f7db91b372ab0$var$clearResults();
    for (const service of filterServices){
        let card = $712f7db91b372ab0$var$createServiceCard(service);
        if (service.Stage1 > 0) {
            let stage1Container = document.querySelector("#stage1-results");
            stage1Container.appendChild(card);
        }
        if (service.Stage2 > 0) {
            let stage2Container = document.querySelector("#stage2-results");
            stage2Container.appendChild(card);
        }
        if (service.Stage3 > 0) {
            let stage3Container = document.querySelector("#stage3-results");
            stage3Container.appendChild(card);
        }
        if (service.Stage4 > 0) {
            let stage4Container = document.querySelector("#stage4-results");
            stage4Container.appendChild(card);
        }
        $712f7db91b372ab0$var$addVisibleTags(card, service);
    }
}
// Clears results from stage containers (prevents duplicate cards if answers are modified)
function $712f7db91b372ab0$var$clearResults() {
    let serviceCards = document.querySelectorAll("#stage1-results .service-card, #stage2-results .service-card, #stage3-results .service-card, #stage4-results .service-card");
    for (const card of serviceCards)card.remove();
}
// Takes a single service and returns a service card component
function $712f7db91b372ab0$var$createServiceCard(service) {
    let master = document.querySelector("#service-card-master > .service-card");
    let card = master.cloneNode(true);
    // Create header container
    let heading = card.querySelector(".heading-container > h3");
    // Add title
    heading.textContent = service.Title;
    // Add logo
    let logo = card.querySelector(".image-container > img");
    let src = service.Organisation.Logo;
    if (src.length > 0) {
        logo.setAttribute("src", "https://www.smhn.org.uk/" + service.Organisation.Logo);
        logo.classList.add("active");
    }
    // Add organisation if available
    if (service.OrganisationID) {
        let orgHeading = document.createElement("span");
        heading.before(orgHeading);
        orgHeading.classList.add("active");
        orgHeading.textContent = service.Organisation.Name;
    }
    // Add card text
    let cardText = card.querySelector(".text-container > p");
    cardText.textContent = service.CardText;
    // Add phone if available
    if (service.ContactPhone) {
        let phoneListItem = card.querySelector(".icon-list-item.phone");
        let phoneLink = card.querySelector(".icon-list-item.phone > a");
        phoneListItem.classList.add("active");
        phoneLink.setAttribute("href", "tel:" + service.ContactPhone.trim());
    }
    // Add email if available
    if (service.ContactEmail) {
        let emailListItem = card.querySelector(".icon-list-item.email");
        let emailLink = card.querySelector(".icon-list-item.email > a");
        emailListItem.classList.add("active");
        emailLink.setAttribute("href", "mailto:" + service.ContactEmail);
    }
    // Add phone if available
    if (service.WebsiteLink) {
        let webListItem = card.querySelector(".icon-list-item.website");
        let webLink = card.querySelector(".icon-list-item.website > a");
        webListItem.classList.add("active");
        webLink.setAttribute("href", "https://" + service.WebsiteLink);
    }
    return card;
}
// Adds classes to tag container to display relevant tags
function $712f7db91b372ab0$var$addVisibleTags(card, service) {
    let tagContainer = card.querySelector(".tag-container");
    if (service.Group_Male) tagContainer.classList.add("male");
    if (service.Group_Female) tagContainer.classList.add("female");
    if (service.Group_Alcohol) tagContainer.classList.add("alcohol");
    if (service.Group_Drug) tagContainer.classList.add("drug");
    if (service.Group_Parent) tagContainer.classList.add("parent");
    if (service.Group_LookedAfter) tagContainer.classList.add("care");
    if (service.Group_CAMHS) tagContainer.classList.add("camhs");
    if (service.Inst_UoS) tagContainer.classList.add("uos");
    if (service.Inst_Solent) tagContainer.classList.add("solent");
    if (service.Inst_CityCollege) tagContainer.classList.add("citycollege");
    if (service.Inst_ItchenCollege) tagContainer.classList.add("itchencollege");
    if (service.Inst_RichardTaunton) tagContainer.classList.add("richardtaunton");
}
// Adds click events to the stage select buttons to switch between results
function $712f7db91b372ab0$var$setStageButtonClickEvents() {
    const stage1bttn = document.querySelector("#stage1-button");
    const stage2bttn = document.querySelector("#stage2-button");
    const stage3bttn = document.querySelector("#stage3-button");
    const stage4bttn = document.querySelector("#stage4-button");
    stage1bttn.addEventListener("click", function() {
        $712f7db91b372ab0$var$setActiveResults(1);
    });
    stage2bttn.addEventListener("click", function() {
        $712f7db91b372ab0$var$setActiveResults(2);
    });
    stage3bttn.addEventListener("click", function() {
        $712f7db91b372ab0$var$setActiveResults(3);
    });
    stage4bttn.addEventListener("click", function() {
        $712f7db91b372ab0$var$setActiveResults(4);
    });
}
// Changes active results based on stage button clicked, accepts stage value between 1 and 4
function $712f7db91b372ab0$var$setActiveResults(stage) {
    const resultsCard = document.querySelector("#exit_result");
    const resultsContainers = resultsCard.getElementsByClassName("result-container");
    let i = 0;
    for (const container of resultsContainers){
        container.classList.remove("active");
        // Can assume containers always ordered stage 1-4
        const containerStage = i + 1;
        if (containerStage === stage) resultsContainers[i].classList.add("active");
        i += 1;
    }
}


//# sourceMappingURL=smhn.4c8683bb.js.map
